module.exports = __webpack_public_path__ + "img/order_icon.841f6351.svg";